export default function VersionCardSkeleton({ count = 4 }: { count?: number }): JSX.Element {
  return (
    <div className="flex flex-col gap-2" aria-hidden="true">
      {Array(count)
        .fill(0)
        .map((_, i) => (
          <div className="flex items-start gap-2 rounded-lg px-3 py-2" key={i}>
            <div className="size-8 shrink-0 animate-pulse rounded-full bg-slate-200" />

            <div className="flex min-w-0 flex-1 flex-col gap-1.5">
              <div className="h-3.5 w-24 animate-pulse rounded bg-slate-200" />
              <div className="h-3 w-4/5 animate-pulse rounded bg-slate-200" />
              <div className="h-2.5 w-16 animate-pulse rounded bg-slate-200" />
            </div>
          </div>
        ))}
    </div>
  );
}
